import { Product } from "@/types";
import { FormBottom } from "../../components/forms/form-bottom";
import { FormHeader } from "../../components/forms/form-header";
import { FormUser } from "../../components/forms/form-user";

type FormPageProps = {
  listProducts: Product[];
}

export default function FormPage({ listProducts }: FormPageProps) {
  return (
    <main className="min-h-screen">
      <FormHeader />
      <FormUser listProducts={listProducts} />
      <FormBottom />
    </main>
  );
}